<template>
  <div id="download-template" class="m-t-10">
    <div class="alert alert-danger" v-if="is_error">
      <i class="bi bi-info-circle"></i> {{ title }}
    </div>
    <form action="#" v-on:submit.prevent="checkCountBerita">
      <div class="form-group">
        <label for="tanggal">Tanggal Awal</label> <br />
        <date-picker
          v-model="form_add.from"
          valueType="format"
          type="datetime"
          class="w-100"
        ></date-picker>
      </div>
      <div class="form-group">
        <label for="tanggal">Tanggal Akhir</label> <br />
        <date-picker
          v-model="form_add.to"
          valueType="format"
          type="datetime"
          class="w-100"
        ></date-picker>
      </div>
      <div class="form-group">
        <label for="tanggal">Jenis Data</label>
        <select
          name="jenis_data"
          id="jenis_data"
          v-model="form_add.tipe"
          class="form-control"
          style="cursor: pointer"
          required
        >
          <option value="medsos">Media Sosial</option>
          <option value="medkon">Media Konvensional</option>
        </select>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Download</button>
      </div>
    </form>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
export default {
  nama: "modal_download_template",
  components: {
    DatePicker,
  },
  data() {
    return {
      is_error: false,
      title: "",
      form_add: {
        from: null,
        to: null,
        tipe: "",
        id_project: this.$store.getters.user.id_project,
      },
      timezone: "",
    };
  },
  methods: {
    checkCountBerita: function() {
      this.is_error = false;
      let params = {
        from: moment(this.form_add.from).format("YYYY-MM-DD HH:mm:ss"),
        to: moment(this.form_add.to).format("YYYY-MM-DD HH:mm:ss"),
        tipe: this.form_add.tipe,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let url =
        process.env.VUE_APP_API_URL +
        "streams/count/" +
        this.form_add.id_project +
        "?" +
        query;
      this.$http
        .get(url)
        .then((res) => {
          if (res.data.total > 0) {
            if (res.data.total <= 75000) {
              this.is_error = false;
              this.submitForm();
            } else {
              this.title =
                "Jumlah data telah mencapai batas export mention. Silahkan gunakan rentang waktu yang lebih pendek";
              this.is_error = true;
            }
          } else {
            this.title = "Mohon maaf, tidak ada berita pada tanggal tersebut.";
            this.is_error = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm: function() {
      const params = {
        from: moment(this.form_add.from).format("YYYY-MM-DD HH:mm:00"),
        to: moment(this.form_add.to).format("YYYY-MM-DD HH:mm:59"),
        tipe: this.form_add.tipe,
        id_project: this.form_add.id_project,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      // let api =
      //   "https://be.kurasi.media/be-export/export-datacleansing?" + query;
      let api =
        process.env.VUE_APP_API_URL + "new-export-datacleansing-excel?" + query;
      window.open(api);
    },
  },
};
</script>
